import classNames from 'classnames'
import { h, JSX } from 'preact'

export interface PaymentErrorProps {
    title: string
    message: string
    class?: string
}

export const PaymentError = (props: PaymentErrorProps): JSX.Element => (
    <div className={classNames('payment-error', props.class)}>
        <h2 className="payment-error__title">{props.title}</h2>
        <div className="payment-error__message">{props.message}</div>
    </div>
)
